import { render, staticRenderFns } from "./WorkflowStatistics.vue?vue&type=template&id=6b87c1a7&scoped=true"
import script from "./WorkflowStatistics.vue?vue&type=script&lang=js"
export * from "./WorkflowStatistics.vue?vue&type=script&lang=js"
import style0 from "./WorkflowStatistics.vue?vue&type=style&index=0&id=6b87c1a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b87c1a7",
  null
  
)

export default component.exports